// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xy-1";
export var printerIcon = "_xy-0";